import React from "react";
import selectors from "selectors";
import { useSelector } from "react-redux";
import useTranslate from "hooks/use-translate-language";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel
} from "@mui/material";
import "./schedule-chat.scss";

const ChooseTopic = ({ topicCategory, setTopicCategory }) => {
  const topic_categories = useSelector(selectors.getChatTopics);
  const translate = useTranslate();

  const handleKeyDown = (e, t, index) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setTopicCategory(t.topic_id);
    }
    // Arrow key navigation
    if (e.key === "ArrowDown" || e.key === "ArrowRight") {
      e.preventDefault();
      const nextIndex = (index + 1) % topic_categories.length;
      const nextTopic = topic_categories[nextIndex];
      setTopicCategory(nextTopic.topic_id);
      // Focus next radio button after state update
      setTimeout(() => {
        const radioButtons = document.querySelectorAll('[role="radio"]');
        radioButtons[nextIndex]?.focus();
      }, 0);
    }
    if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
      e.preventDefault();
      const prevIndex = index === 0 ? topic_categories.length - 1 : index - 1;
      const prevTopic = topic_categories[prevIndex];
      setTopicCategory(prevTopic.topic_id);
      // Focus previous radio button after state update
      setTimeout(() => {
        const radioButtons = document.querySelectorAll('[role="radio"]');
        radioButtons[prevIndex]?.focus();
      }, 0);
    }
  };

  return (
    <div className="topic-container">
      <FormControl component="fieldset" style={{ width: "100%" }}>
        <FormLabel component="legend" className="topic-title">
          {translate("chooseATopic")}
        </FormLabel>
        <RadioGroup
          name="topic-category"
          value={topicCategory}
          onChange={(e) => setTopicCategory(e.target.value)}
        >
          {topic_categories.map(t => (
            <FormControlLabel
              key={t.topic_id}
              value={t.topic_id}
              control={
                <Radio
                  sx={{
                    position: "absolute",
                    opacity: 0,
                    width: 0,
                    height: 0,
                    margin: 0,
                    padding: 0
                  }}
                />
              }
              label={t.topic_name}
              className={`topic-radio-option ${topicCategory === t.topic_id ? 'selected' : ''}`}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default ChooseTopic;
